import { createSelector } from 'reselect';

const selectOpennetworkDomains = (state: any) => state.opennetworkDomains;


export const selectOpennetworkDomainsCurrentItem = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.current);

export const selectOpennetworkDomainsListItems = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.list);

export const selectOpennetworkDomainsItemById = (itemId: any) =>
    createSelector(selectOpennetworkDomainsListItems, (list) => list.result.items.find((item: any) => item._id === itemId));

export const selectOpennetworkDomainCreatedItem = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.create);

export const selectOpennetworkDomainQueryItems = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.query);

export const selectOpennetworkDomainUpdatedItem = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.update);

export const selectOpennetworkDomainReadItem = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.read);

export const selectOpennetworkDomainDeletedItem = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.delete);

export const selectOpennetworkDomainSearchedItems = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.search);

export const selectOpennetworkDomainItemsCount = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.count);

export const selectOpennetworkDomainItemsFilter = createSelector([selectOpennetworkDomains], (opennetworkDomains) => opennetworkDomains.filter);